import React from 'react';
import './ValidationModal.css';

const ValidationModal = ({ pendencies, onClose, onExecuteAnyway }) => {
  if (!pendencies || pendencies.length === 0) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="validation-modal-backdrop" onClick={handleBackdropClick}>
      <div className="validation-modal">
        <div className="validation-modal-header">
          <h3>⚠️ Avisos encontrados</h3>
          <button className="validation-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="validation-modal-content">
          <p className="validation-modal-description">
            {pendencies.length === 1 
              ? 'Foi encontrado um aviso que precisa ser corrigido antes de executar:' 
              : `Foram encontrados ${pendencies.length} avisos que precisam ser corrigidos antes de executar:`
            }
          </p>
          
          <div className="validation-modal-list">
            {pendencies.map((node, index) => (
              <div key={`${node.nodeId}-${index}`} className={`validation-item ${index === 0 ? 'first-item' : ''}`}>
                <div className="validation-item-header">
                  <span className="validation-item-number">{index + 1}</span>
                  <span className="validation-item-title">
                    Nó &ldquo;{node.nodeLabel}&rdquo;
                    {index === 0 && pendencies.length > 1 && (
                      <span className="first-item-indicator">← Começar aqui</span>
                    )}
                  </span>
                </div>
                <ul className="validation-item-pendencies">
                  {node.pendencies.map((pendency, pIndex) => (
                    <li key={pIndex}>{pendency}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        
        <div className="validation-modal-footer">
          <button className="validation-modal-button secondary" onClick={onExecuteAnyway}>
            Executar mesmo assim
          </button>
          <button className="validation-modal-button primary" onClick={onClose}>
            Corrigir avisos
          </button>
        </div>
      </div>
    </div>
  );
};

export default ValidationModal;